// extracted by mini-css-extract-plugin
export default {"sendModal":"DMSend_sendModal__go6a-"};